import { Descriptions } from 'antd';
import './index.less';
export default Descriptions;
